import React, { useRef } from "react";
import { useState, useEffect } from "react";
import AppContext from "../Context/Context";
import * as XLSX from "xlsx";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import axiosAuth from "../Axios/Interceptors";
import moment from "moment";
import { useGlobalState } from "../Context/GlobalStateContext";
type MyNotificationsProps = {
  ObjectType: any;
  ObjectIds: any;
};
function NotificationsPreview(props: MyNotificationsProps) {
  const [showAnimation, setShowAnimation] = useState(false);
  const [showNotifications, setNotifications] = useState(false);
  const [notificationsListsData, setNotificationsListsData] = useState<any>([]);
  const [totalCount, setTotalCount] = useState(0);
  const globalState = useGlobalState();

  const previewRef = useRef<any>(null);

  useEffect(() => {
    // Function to handle outside clicks
    const handleClickOutside = (event: any) => {
      // Check if the click target is outside the component's DOM node
      if (previewRef.current && !previewRef.current.contains(event.target)) {
        setNotifications(false);
        // console.log(event.target);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    getNotificationsStatsData();
  }, [globalState.UpdateNotificationCount]);

  function getNotificationsStatsData() {
    let object = {} as any;
    object.objecttype = props.ObjectType;
    object.objectids = props.ObjectIds;
    object.linkedobjecttype = 1;
    object.linkedobjectids = "";
    object.typeofdata = 1;
    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuote/GetNotificationsStatsData",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          setTotalCount(l_response[0][0].TotalCount);
          setNotificationsListsData(l_response[1]);
          //console.log(l_response);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function setNotificationsStatusDataLocally(
    pid: any,
    actiontype: any,
    index: any
  ) {
    let thisNotificationsListsData = [...notificationsListsData];

    if (actiontype == 1) {
      thisNotificationsListsData[index].IsRead =
        !thisNotificationsListsData[index].IsRead;
    } else if (actiontype == 2) {
      thisNotificationsListsData[index].IsFlag =
        !thisNotificationsListsData[index].IsFlag;
    }

    setNotificationsListsData(thisNotificationsListsData);
    setNotificationsStatusData(pid, actiontype);
  }

  function setNotificationsStatusData(pid: any, actiontype: any) {
    let object = {} as any;
    object.pid = pid;
    object.actiontype = actiontype;
    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuote/SetNotificationsStatusData",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          getNotificationsStatsData();
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  return (
    <>
      {showAnimation && <LoadingAnimation />}
      <div className="folder-inn" ref={previewRef}>
        <div className="flex-d p-relative">
          <a
            onClick={() => setNotifications(!showNotifications)}
            className="p-relative"
            style={{ height: 20 }}
          >
            <img src="/images/bell.svg" width="25px" height="20" />
            {totalCount > 0 && (
              <span className="notify-count notify-head">{totalCount}</span>
            )}
          </a>
          {showNotifications && (
            <div className="notify-drop notificationsalignment">
              <div className="flex-d flex-ac flex-jsb btn-notify">
                <div className="flex-daj btn-start">
                  <a href="/mynotifications" className="btn-primary flex-daj">
                    View All
                  </a>
                </div>
                <div className="flex-daj btn-start">
                  <a
                    href="/mynotifications?ur=true"
                    className="btn-primary flex-daj"
                  >
                    {totalCount} Unread
                  </a>
                </div>
              </div>
              <div className="notify-list">
                {notificationsListsData &&
                  notificationsListsData.map((item: any, index: any) => (
                    <div
                      key={index}
                      className={`notify-text ${
                        item.IsRead ? "" : "notify-Bold"
                      }`}
                    >
                      {/* <span>{item.Title1} - </span>
                  <span>{item.Title2} - </span> */}
                      <a className="drop-display-text" href={item.SourceLink}>
                        {item.DisplayText}
                      </a>
                      <a
                        onClick={() =>
                          setNotificationsStatusDataLocally(
                            item.PTNotificationUserID,
                            1,
                            index
                          )
                        }
                      >
                        <img
                          src={
                            item.IsRead
                              ? "images/read.svg"
                              : "images/unread.svg"
                          }
                          id="pre"
                          width={22}
                          height={22}
                        />

                        {/* {item.IsRead && (
                        <img src="images/read.svg" id="pre" width={22} height={22} />
                      )}
                      {!item.IsRead && (
                        <img src="images/unread.svg" id="pre" width={22} height={22} />
                      )} */}
                      </a>
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default NotificationsPreview;
